import { LocationVarKey } from '@swivl-mono/types';
import { IS_EQUAL, IS_NOT_EQUAL } from '../../../Components/Worksheets/Types/Worksheet.Interface';
import { DropdownRow, Indent, PageHeader, Section, SectionHeader, SwitchRow, TextAreaRow } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return <>
    <PageHeader {...page} subheading="Bot-initiated escalation settings." >Bot Escalations</PageHeader>

    <SectionHeader {...page} subheading="When your bot identifies a sales lead, collect the user's contact information before escalating." hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")}> Bot Initiated - Sales Escalation </SectionHeader>
    <SwitchRow {...page} keyName={LocationVarKey.HasBotInitiatedEscalationsSalesCollectProfile} label="Collect Profile" hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")} />
    <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasBotInitiatedEscalationsSalesCollectProfile, "1")}>
      <TextAreaRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")}
        marginTop
        label="Message 1"
        keyName={LocationVarKey.ProfileSettingBotInititatedSalesMessage}
      />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")}
        marginTop
        label=" Collection Method"
        keyName={LocationVarKey.ProfileSettingBotInititatedSalesCollectionMethod}
        options={[
          {
            label: "Conversational",
            value: "Conversational"
          },
          {
            label: "Info Collect Card",
            value: "Card"
          }
        ]} />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")}
        marginTop
        label=" Preferred Contact Method"
        keyName={LocationVarKey.ProfileSettingBotInititatedSalesContactMethod}
        options={[
          {
            label: "Phone Number",
            value: "Phone"
          },
          {
            label: "Email",
            value: "Email"
          }
        ]} />

      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")} keyName={LocationVarKey.ProfileSettingBotInititatedSalesWantShortProfile} label="Short Profile" />
      <Indent {...page} >
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingBotInititatedSalesWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "1")} label="Make Secondary Contact Method Optional" />
      </Indent>
      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsSales, "0")} keyName={LocationVarKey.ProfileSettingBotInititatedSalesWantConfirmProfile} label="Confirm Profile" />
    </Section>


    <SectionHeader {...page} subheading="When your bot identifies a user wanting to get in contact with customer service, collect their contact information before escalating." hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")}> Bot Initiated - Service Escalation </SectionHeader>
    <SwitchRow {...page} keyName={LocationVarKey.HasBotInitiatedEscalationsServiceCollectProfile} label="Collect Profile" hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")} />
    <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasBotInitiatedEscalationsServiceCollectProfile, "1")}>
      <TextAreaRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ProfileSettingBotInititatedServiceMessage}
      />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")}
        marginTop
        label=" Collection Method"
        keyName={LocationVarKey.ProfileSettingBotInititatedServiceCollectionMethod}
        options={[
          {
            label: "Conversational",
            value: "Conversational"
          },
          {
            label: "Info Collect Card",
            value: "Card"
          }
        ]} />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")}
        marginTop
        label=" Preferred Contact Method"
        keyName={LocationVarKey.ProfileSettingBotInititatedServiceContactMethod}
        options={[
          {
            label: "Phone Number",
            value: "Phone"
          },
          {
            label: "Email",
            value: "Email"
          }
        ]} />

      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")} keyName={LocationVarKey.ProfileSettingBotInititatedServiceWantShortProfile} label="Short Profile" />
      <Indent {...page} >
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingBotInititatedServiceWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "1")} label="Make Secondary Contact Method Optional" />
      </Indent>
      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsService, "0")} keyName={LocationVarKey.ProfileSettingBotInititatedServiceWantConfirmProfile} label="Confirm Profile" />
    </Section>


    <SectionHeader {...page} subheading="When your bot isn't confident in its reply, collect the user's contact information before escalating." hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")}> Bot Initiated - Low Confidence Escalation </SectionHeader>
    <SwitchRow {...page} keyName={LocationVarKey.HasBotInitiatedEscalationsLowConfidenceCollectProfile} label="Collect Profile" hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")} />
    <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasBotInitiatedEscalationsLowConfidenceCollectProfile, "1")}>
      <TextAreaRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ProfileSettingLowConfidenceMessage}
      />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")}
        marginTop
        label=" Collection Method"
        keyName={LocationVarKey.ProfileSettingLowConfidenceCollectionMethod}
        options={[
          {
            label: "Conversational",
            value: "Conversational"
          },
          {
            label: "Info Collect Card",
            value: "Card"
          }
        ]} />
      <DropdownRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")}
        marginTop
        label=" Preferred Contact Method"
        keyName={LocationVarKey.ProfileSettingLowConfidenceContactMethod}
        options={[
          {
            label: "Phone Number",
            value: "Phone"
          },
          {
            label: "Email",
            value: "Email"
          }
        ]} />
      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")} keyName={LocationVarKey.ProfileSettingLowConfidenceWantShortProfile} label="Short Profile" />
      <Indent {...page} >
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingLowConfidenceWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingLowConfidenceWantShortProfile, "1")} label="Make Secondary Contact Method Optional" />
      </Indent>
      <SwitchRow {...page} hideIf={IS_EQUAL(LocationVarKey.WantsBotInitiatedEscalationsLowConfidence, "0")} keyName={LocationVarKey.ProfileSettingLowConfidenceWantConfirmProfile} label="Confirm Profile" />
    </Section>






  </>
}